/* Owlkrown Cart Drawer Recommendations - v16 */
/* v16: SL straps are no longer banned outright. "SL" means wider and padded for a
        heavier body, not "only fits a Leica SL" (the SL Line copy says so, and the
        Trailflex SL lists Leica, Fuji, Sony, Hasselblad, Nikon and Canon). They are now
        offered ON an SL cart and still withheld from an M or Q cart. */
/* v15: HARD BLOCKLIST (Perch, lugs, split rings, multi attachment, quick release, covers,
        replacements, gift cards) + price floor + straps-only fallback collections
        + adjustable straps lead when the cart holds a kit/bundle.
        Rationale: a $794 M.O.A.K. cart was being upsold $9.99 lug covers and a strap display. */
/* v14: fix budget floor bug - hide recs when 5/5 added instead of always showing 1 more */
/* v13: cache rendered recs HTML so drawer close/reopen restores instead of re-fetching */
/* v12: fix image URLs from collection API (object vs string) */
/* v11: collection fallback when filtered recs too few */
/* Dedup same-product-diff-color + multi-product fetch + sticky deduct */
/* Smart tiers + color matching + no duplicate categories */
/* Camera compatibility + deduct-on-select + direct onclick */

var _cartRecsRunning = false;
var MAX_RECS = 5;
var _recsAdded = window._recsAdded || 0;
window._recsAdded = _recsAdded;
/* Timestamp lock: block re-init for 30s after an add */
var _recsAddedAt = window._recsAddedAt || 0;
window._recsAddedAt = _recsAddedAt;
/* Cache rendered recs HTML so drawer close/reopen restores instantly */
var _recsHtmlCache = window._recsHtmlCache || '';
window._recsHtmlCache = _recsHtmlCache;

/* ============================================================
   NEVER-RECOMMEND RULES  (edit these two lists to change policy)
   ============================================================ */

/* Any product whose title contains one of these is NEVER shown in the cart drawer,
   no matter where it came from (complementary metafield or collection fallback). */
var BLOCKED_TERMS = [
  'perch',              /* The Perch Self-Standing Strap Display */
  'lug',                /* Lug Protection / Lug Cover / Square Lug to Split Ring */
  'split ring',
  'multi attachment',
  'quick release',
  'replacement',
  'cover replacement',
  'gift card',
  'engraving',
  'sample',
  'test product'
];

/* Nothing under this price is ever shown, anywhere. 4000 = $40.00
   (kills lug covers, lug protection and every other parts-bin item) */
var MIN_REC_PRICE_CENTS = 4000;

/* Higher floor when the cart holds a kit or bundle. Someone spending $794 on a
   M.O.A.K. is not shopping for a $49.99 add-on. 6000 = $60.00 */
var KIT_CART_MIN_PRICE_CENTS = 6000;

/* Price in cents, from either the /recommendations JSON (p.price, cents)
   or the /collections/x/products.json shape (variants[0].price, dollar string). */
var getPriceCents = window.getPriceCents = function (p) {
  if (!p) return 0;
  if (typeof p.price === 'number') return p.price;
  if (typeof p.price === 'string' && p.price !== '') {
    return Math.round(parseFloat(p.price) * 100);
  }
  if (p.variants && p.variants.length > 0 && p.variants[0].price != null) {
    var v = p.variants[0].price;
    if (typeof v === 'number') return v;
    return Math.round(parseFloat(v) * 100);
  }
  return 0;
};

var isBlocked = window.isBlocked = function (title) {
  if (!title) return true;
  var t = title.toLowerCase();
  for (var i = 0; i < BLOCKED_TERMS.length; i++) {
    if (t.indexOf(BLOCKED_TERMS[i]) !== -1) return true;
  }
  return false;
};

/* Single gate every candidate must pass before it can be recommended.
   hasKit raises the floor for kit and bundle carts. */
var isEligible = window.isEligible = function (p, hasKit) {
  if (!p || !p.title) return false;
  if (isBlocked(p.title)) return false;
  if (p.available === false) return false;
  var floor = hasKit ? KIT_CART_MIN_PRICE_CENTS : MIN_REC_PRICE_CENTS;
  var cents = getPriceCents(p);
  if (cents > 0 && cents < floor) return false;
  return true;
};

/* -- Product Category Detection -- */
var isStrapProduct = function(title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return t.indexOf('strap') !== -1 || t.indexOf('wristloop') !== -1 || t.indexOf('wristflex') !== -1 ||
    t.indexOf('thumb strap') !== -1 || t.indexOf('twinpad') !== -1 || t.indexOf('point & shoot') !== -1 ||
    t.indexOf('black mamba') !== -1 || t.indexOf('helliot') !== -1 || t.indexOf('classic round') !== -1 ||
    t.indexOf('classic flat') !== -1 || t.indexOf('raw vintage') !== -1 || t.indexOf('comfy') !== -1 ||
    t.indexOf('trailflex') !== -1 || t.indexOf('m.o.a.s') !== -1;
};

var isWristStrap = function(title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return (t.indexOf('wrist') !== -1 || t.indexOf('shorty') !== -1 || t.indexOf('thumb strap') !== -1) && isStrapProduct(title);
};

var isNeckStrap = function(title) {
  return isStrapProduct(title) && !isWristStrap(title);
};

/* Kept for classification only - every one of these is now blocked outright. */
var isStrapAccessory = function(title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return t.indexOf('lug') !== -1 || t.indexOf('multi attachment') !== -1 ||
    t.indexOf('split ring') !== -1 || t.indexOf('quick release') !== -1;
};

/* The most versatile straps we sell: one length fits every camera and every carry style.
   These lead the list whenever the cart holds a kit or bundle. */
var isAdjustableStrap = window.isAdjustableStrap = function (title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return t.indexOf('adjustable') !== -1 || t.indexOf('trailflex') !== -1 || t.indexOf('wristflex') !== -1;
};

var isSLStrap = window.isSLStrap = function (title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return isStrapProduct(title) &&
    (t.indexOf(' sl ') !== -1 || t.indexOf(' sl2') !== -1 || t.indexOf(' sl3') !== -1);
};

var isKitOrBundle = window.isKitOrBundle = function (title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return t.indexOf('m.o.a.k') !== -1 || t.indexOf('moak') !== -1 ||
    t.indexOf('mother of all kits') !== -1 || t.indexOf('pro kit') !== -1 ||
    t.indexOf('prokit') !== -1 || t.indexOf('ultra kit') !== -1 ||
    t.indexOf('bundle') !== -1;
};

var cartHasKit = window.cartHasKit = function (cart) {
  if (!cart || !cart.items) return false;
  for (var i = 0; i < cart.items.length; i++) {
    if (isKitOrBundle(cart.items[i].product_title || '')) return true;
  }
  return false;
};

var isShutterTopper = function(title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return t.indexOf('shutter topper') !== -1 || t.indexOf('cupcake') !== -1 ||
    t.indexOf('fractal') !== -1 || t.indexOf('sprocket') !== -1;
};

var isBigTicket = function(title) {
  if (!title) return false;
  var t = title.toLowerCase();
  return t.indexOf('flexgrip') !== -1 || t.indexOf('hotgrip') !== -1 || t.indexOf('hot grip') !== -1 ||
    t.indexOf('eyekup') !== -1 || t.indexOf('eye kup') !== -1 || t.indexOf('pro kit') !== -1 ||
    t.indexOf('ultra kit') !== -1 || t.indexOf('body cap') !== -1;
};

/* -- Category label for dedup -- */
var getCategoryKey = function(title) {
  if (!title) return 'other';
  if (isWristStrap(title)) return 'wrist-strap';
  if (isNeckStrap(title)) return 'neck-strap';
  if (isStrapAccessory(title)) return 'strap-acc';
  if (isShutterTopper(title)) return 'shutter-topper';
  if (isBigTicket(title)) return 'big-ticket';
  return 'other';
};

/* -- Base product name (strip color/finish to detect same product diff color) --
   Owlkrown titles are "Family Name - Colour", so the family is everything before the
   LAST " - ". The old version instead stripped a word list that mixed colours in with
   family names ('helliot', 'classic round', 'black mamba'), which both collapsed
   different products together AND let colours it had never heard of through - that is
   why three Trailflex colours could appear in one list. */
var COLOR_WORDS = [
  'black with red accent', 'black with red', 'diamond blue', 'pixel orange',
  'pixel pink', 'red dune', 'matte black', 'black chrome', 'silver chrome',
  'solid brass', 'black patina', 'stealth', 'safari', 'monochrome', 'outback',
  'alpha', 'expedition', 'reporter', 'oxblood', 'sahara', 'blaze', 'olive',
  'tan', 'brown', 'black', 'navy', 'grey', 'gray', 'midnight', 'cognac',
  'camel', 'ink', 'titanium', 'silver', 'gold', 'copper', 'red', 'blue',
  'green', 'purple', 'pink', 'orange', 'polished', 'brushed'
];

var getBaseProduct = function(title) {
  if (!title) return '';
  var t = title.toLowerCase().trim();
  /* drop a trailing parenthetical: "(2 pair)", "(Bundle & Save $70)", "(12 mm)" */
  t = t.replace(/\s*\([^()]*\)\s*$/, '');
  /* keep the family, drop the colour that follows the last " - " */
  var dash = t.lastIndexOf(' - ');
  if (dash > 0) t = t.slice(0, dash);
  /* and catch colours that were appended without a dash */
  for (var i = 0; i < COLOR_WORDS.length; i++) {
    t = t.split(COLOR_WORDS[i]).join('');
  }
  /* "padded" is a variant of the same strap, not a separate thing to upsell
     next to it - collapse it so the list never shows both back to back */
  t = t.split('padded').join('');
  /* same for the SL build: Trailflex SL and Trailflex are one strap in two weights, and
     the SL-first ordering below decides which build an SL cart is shown */
  t = t.split(' sl ').join(' ');
  if (t.slice(-3) === ' sl') t = t.slice(0, -3);
  /* collapse whitespace and trim dashes */
  return t.replace(/[\s\-]+/g, ' ').replace(/^\s+|\s+$/g, '');
};

/* -- Color Matching -- */
var STRAP_COLORS = [
  'stealth', 'safari', 'monochrome', 'black mamba', 'outback', 'alpha',
  'expedition', 'reporter', 'diamond blue', 'pixel orange', 'red dune',
  'helliot', 'classic round', 'classic flat', 'raw vintage', 'comfy',
  'black with red', 'olive', 'tan', 'brown', 'black', 'navy', 'grey',
  'gray', 'midnight', 'cognac', 'camel', 'ink'
];

var getStrapColor = function(title) {
  if (!title) return '';
  var t = title.toLowerCase();
  for (var i = 0; i < STRAP_COLORS.length; i++) {
    if (t.indexOf(STRAP_COLORS[i]) !== -1) return STRAP_COLORS[i];
  }
  return '';
};

/* -- Camera System Detection -- */
var getProductCameras = window.getProductCameras = function(title) {
  if (!title) return ['universal'];
  var t = title.toLowerCase();

  /* SL straps: right for an SL body, withheld from everything else (see isCompatible) */
  if ((t.indexOf(' sl ') !== -1 || t.indexOf(' sl2') !== -1 || t.indexOf(' sl3') !== -1) &&
      (t.indexOf('strap') !== -1 || t.indexOf('wrist') !== -1 || t.indexOf('twin') !== -1 || t.indexOf('trail') !== -1)) {
    return ['leica-sl'];
  }

  /* Straps (non-SL): universal */
  if (isStrapProduct(title)) {
    if (t.indexOf(' sl ') === -1 && t.indexOf(' sl2') === -1 && t.indexOf(' sl3') === -1) {
      if (t.indexOf('alpha') !== -1) return ['universal','sony-affinity'];
      return ['universal'];
    }
  }

  /* Shutter Toppers: universal */
  if (isShutterTopper(title)) return ['universal'];

  /* Multi Attachment Kit, Split Ring, Quick Release, Perch, Gift Card, Lug: universal */
  if (t.indexOf('multi attachment') !== -1 || t.indexOf('split ring') !== -1 ||
      t.indexOf('quick release') !== -1 || t.indexOf('perch') !== -1 || t.indexOf('gift card') !== -1 ||
      t.indexOf('lug') !== -1) {
    return ['universal'];
  }

  /* Slim M-EyeKup 12mm: all M EXCEPT M10, M11, M3v1 */
  if ((t.indexOf('slim m-eyekup') !== -1 || t.indexOf('slim m eyekup') !== -1) && t.indexOf('12') !== -1) {
    return ['leica-m3','leica-m4','leica-m5','leica-m6','leica-m7','leica-m8','leica-m9','leica-240','leica-m265','leica-mev1'];
  }

  /* Slim M-EyeKup 14mm: M10 and M11 only */
  if ((t.indexOf('slim m-eyekup') !== -1 || t.indexOf('slim m eyekup') !== -1) && t.indexOf('14') !== -1) {
    return ['leica-m10','leica-m11'];
  }

  /* Slim M-EyeKup (generic / M-Series) */
  if (t.indexOf('slim m-eyekup') !== -1 || t.indexOf('slim m eyekup') !== -1) {
    return ['leica-m3','leica-m4','leica-m5','leica-m6','leica-m7','leica-m8','leica-m9','leica-240','leica-m265','leica-m10','leica-m11','leica-mev1'];
  }

  /* M-EyeKup (non-slim) */
  if (t.indexOf('m-eyekup') !== -1 || t.indexOf('m eyekup') !== -1 || t.indexOf('m-series') !== -1) {
    return ['leica-m3','leica-m4','leica-m5','leica-m6','leica-m7','leica-m8','leica-m9','leica-240','leica-m265','leica-m10','leica-m11','leica-mev1'];
  }

  /* Weather Sealed M Body Cap: all M system */
  if (t.indexOf('m body cap') !== -1 || t.indexOf('m camera body cap') !== -1) {
    return ['leica-m3','leica-m4','leica-m5','leica-m6','leica-m7','leica-m8','leica-m9','leica-240','leica-m265','leica-m10','leica-m11','leica-mev1','leica-m3v1'];
  }

  /* Sony Body Cap */
  if (t.indexOf('sony') !== -1 || t.indexOf('alpha') !== -1) return ['sony-alpha'];

  /* HotGrip: camera specific from title */
  if (t.indexOf('hotgrip') !== -1 || t.indexOf('hot grip') !== -1) {
    var cams = [];
    if (t.indexOf('q2') !== -1) cams.push('leica-q2');
    if (t.indexOf('q3') !== -1) cams.push('leica-q3');
    if (t.indexOf('m10') !== -1) cams.push('leica-m10');
    if (t.indexOf('m11') !== -1) cams.push('leica-m11');
    if (t.indexOf('m ev') !== -1 || t.indexOf('mev') !== -1 || t.indexOf('m-ev') !== -1) cams.push('leica-mev1');
    return cams.length > 0 ? cams : ['universal'];
  }

  /* FlexGrip: camera specific from title */
  if (t.indexOf('flexgrip') !== -1 || t.indexOf('flex grip') !== -1) {
    var cams = [];
    if (t.indexOf('q2') !== -1) cams.push('leica-q2');
    if (t.indexOf('q3') !== -1) cams.push('leica-q3');
    if (t.indexOf('m11') !== -1) cams.push('leica-m11');
    if (t.indexOf('m10') !== -1) cams.push('leica-m10');
    if (t.indexOf('m ev') !== -1 || t.indexOf('mev') !== -1 || t.indexOf('m-ev') !== -1) cams.push('leica-mev1');
    if (t.indexOf('sigma') !== -1) cams.push('sigma');
    if (t.indexOf(' sl ') !== -1 || t.indexOf(' sl2') !== -1 || t.indexOf(' sl3') !== -1) cams.push('leica-sl');
    return cams.length > 0 ? cams : ['universal'];
  }

  /* Passthrough Hot Shoe Adapter */
  if (t.indexOf('passthrough') !== -1 || t.indexOf('hot shoe adapter') !== -1) {
    return ['leica-m10','leica-m11','leica-mev1','leica-q2','leica-q3'];
  }

  /* Pro Kit / Ultra Kit: camera specific from title */
  if (t.indexOf('pro kit') !== -1 || t.indexOf('ultra kit') !== -1) {
    var cams = [];
    if (t.indexOf('m10') !== -1) cams.push('leica-m10');
    if (t.indexOf('m11') !== -1) cams.push('leica-m11');
    if (t.indexOf('m ev') !== -1 || t.indexOf('mev') !== -1 || t.indexOf('m-ev') !== -1) cams.push('leica-mev1');
    return cams.length > 0 ? cams : ['universal'];
  }

  /* Sliding Lid Protector: M system */
  if (t.indexOf('sliding lid') !== -1) return ['leica-m10','leica-m11','leica-mev1'];

  /* Anything else built for the SL, the FlexPlate SL3 today */
  if (t.indexOf(' sl ') !== -1 || t.indexOf(' sl2') !== -1 || t.indexOf(' sl3') !== -1) {
    return ['leica-sl'];
  }

  return ['universal'];
};

/* Detect camera system from the PRIMARY product in cart */
var getCartCameras = window.getCartCameras = function(cart) {
  if (!cart || !cart.items || cart.items.length === 0) return ['universal'];

  /* An SL item in the cart settles it outright. Without this an SL3 FlexPlate cart read as
     'universal', which is why an SL owner was shown M and Q straps and never the SL line. */
  for (var sl = 0; sl < cart.items.length; sl++) {
    var slt = (cart.items[sl].product_title || '').toLowerCase();
    if (slt.indexOf(' sl ') !== -1 || slt.indexOf(' sl2') !== -1 || slt.indexOf(' sl3') !== -1) {
      return ['leica-sl'];
    }
  }

  var priority = [
    ['flexgrip', 'flex grip', 'hotgrip', 'hot grip'],
    ['pro kit', 'ultra kit'],
    ['eyekup', 'eye kup'],
    ['body cap'],
    ['sliding lid', 'passthrough']
  ];

  for (var p = 0; p < priority.length; p++) {
    for (var i = 0; i < cart.items.length; i++) {
      var t = (cart.items[i].product_title || '').toLowerCase();
      for (var k = 0; k < priority[p].length; k++) {
        if (t.indexOf(priority[p][k]) !== -1) {
          var cams = getProductCameras(cart.items[i].product_title);
          if (cams.indexOf('universal') === -1 && cams.indexOf('leica-sl') === -1) {
            return cams;
          }
        }
      }
    }
  }

  return ['universal'];
};

/* Check if a recommended product is compatible with the cart cameras */
var isCompatible = window.isCompatible = function(cartCameras, recTitle) {
  var recCams = getProductCameras(recTitle);
  /* SL gear is wider and padded for a heavier body. Correct for an SL cart, over-built for
     an M or a Q, so it is allowed on an SL cart and only there. */
  if (recCams.length === 1 && recCams[0] === 'leica-sl') {
    return cartCameras.indexOf('leica-sl') !== -1;
  }
  if (recCams.indexOf('universal') !== -1) return true;
  if (cartCameras.indexOf('universal') !== -1) return true;
  for (var i = 0; i < cartCameras.length; i++) {
    if (recCams.indexOf(cartCameras[i]) !== -1) return true;
  }
  return false;
};

/* Relevance scoring */
var getRelevanceScore = window.getRelevanceScore = function(cartCameras, recTitle) {
  var recCams = getProductCameras(recTitle);
  var score = 0;
  if (recCams.indexOf('universal') !== -1) score = 1;
  for (var i = 0; i < cartCameras.length; i++) {
    if (recCams.indexOf(cartCameras[i]) !== -1) score = 3;
  }
  if (recCams.indexOf('sony-affinity') !== -1) {
    for (var j = 0; j < cartCameras.length; j++) {
      if (cartCameras[j] === 'sony-alpha') score = 2;
    }
  }
  return score;
};

/* -- Dedup: remove same-product-diff-color -- */
var dedupeProducts = function(products) {
  var seen = {};
  var result = [];
  for (var i = 0; i < products.length; i++) {
    var base = getBaseProduct(products[i].title);
    if (!seen[base]) {
      seen[base] = true;
      result.push(products[i]);
    }
  }
  return result;
};

/* -- Smart Recommendation Tiers -- */
var applySmartTiers = window.applySmartTiers = function(products, cart, cartCameras) {
  var shuffle = function(arr) {
    for (var s = arr.length - 1; s > 0; s--) {
      var r = Math.floor(Math.random() * (s + 1));
      var tmp = arr[s]; arr[s] = arr[r]; arr[r] = tmp;
    }
    return arr;
  };

  var hasKit = cartHasKit(cart);
  var cartIsSL = !!(cartCameras && cartCameras.indexOf('leica-sl') !== -1);

  /* Step 0: drop anything on the never-recommend list, whatever the source */
  var allowed = [];
  for (var b = 0; b < products.length; b++) {
    if (isEligible(products[b], hasKit)) allowed.push(products[b]);
  }
  products = allowed;

  /* Step 1: remove same-product-diff-color duplicates */
  products = dedupeProducts(products);

  /* Detect what's in cart */
  var hasStrap = false;
  var hasWrist = false;
  var hasNeck = false;
  var cartColor = '';
  var cartStrapPrice = 0;

  if (cart && cart.items) {
    for (var i = 0; i < cart.items.length; i++) {
      var pt = cart.items[i].product_title || '';
      if (isStrapProduct(pt)) {
        hasStrap = true;
        if (isWristStrap(pt)) hasWrist = true;
        else hasNeck = true;
        var c = getStrapColor(pt);
        if (c && !cartColor) cartColor = c;
        var itemPrice = cart.items[i].price || 0;
        if (itemPrice > cartStrapPrice) cartStrapPrice = itemPrice;
      }
    }
  }

  /* Sort into buckets */
  var complementStraps = [];
  var shutterToppers = [];
  var bigTickets = [];
  var other = [];

  for (var j = 0; j < products.length; j++) {
    var title = products[j].title;

    /* SL straps: keep them on an SL cart, drop them everywhere else. This check is
       separate from isCompatible and used to discard them unconditionally. */
    if (isSLStrap(title) && !cartIsSL) continue;

    if (hasStrap) {
      if (hasNeck && isWristStrap(title)) { complementStraps.push(products[j]); }
      else if (hasWrist && isNeckStrap(title)) { complementStraps.push(products[j]); }
      else if (isShutterTopper(title)) { shutterToppers.push(products[j]); }
      else if (isBigTicket(title)) { bigTickets.push(products[j]); }
      else { other.push(products[j]); }
    } else {
      if (isStrapProduct(title)) { complementStraps.push(products[j]); }
      else if (isShutterTopper(title)) { shutterToppers.push(products[j]); }
      else if (isBigTicket(title)) { bigTickets.push(products[j]); }
      else { other.push(products[j]); }
    }
  }

  /* Color-match: move matching-color straps to front */
  if (cartColor && complementStraps.length > 1) {
    complementStraps.sort(function(a, b) {
      var ma = (getStrapColor(a.title) === cartColor) ? 1 : 0;
      var mb = (getStrapColor(b.title) === cartColor) ? 1 : 0;
      return mb - ma;
    });
    var matchEnd = 0;
    for (var m = 0; m < complementStraps.length; m++) {
      if (getStrapColor(complementStraps[m].title) === cartColor) matchEnd++;
    }
    var nonMatch = complementStraps.splice(matchEnd);
    shuffle(nonMatch);
    complementStraps = complementStraps.concat(nonMatch);
  } else {
    shuffle(complementStraps);
  }

  shuffle(shutterToppers);
  shuffle(bigTickets);
  shuffle(other);

  /* Expensive strap: prefer expensive complement */
  if (cartStrapPrice > 10000 && complementStraps.length > 1) {
    complementStraps.sort(function(a, b) {
      var ca = getStrapColor(a.title) === cartColor ? 1000000 : 0;
      var cb = getStrapColor(b.title) === cartColor ? 1000000 : 0;
      return (cb + getPriceCents(b)) - (ca + getPriceCents(a));
    });
  }

  /* Kit or bundle in the cart: the adjustable straps lead, they fit any camera
     and any carry style, so they are the one upsell that always makes sense. */
  if (hasKit && complementStraps.length > 1) {
    var adj = [];
    var rest = [];
    for (var a = 0; a < complementStraps.length; a++) {
      if (isAdjustableStrap(complementStraps[a].title)) adj.push(complementStraps[a]);
      else rest.push(complementStraps[a]);
    }
    /* Dearest adjustable strap first - a kit buyer is not shopping on price. */
    adj.sort(function(x, y) { return getPriceCents(y) - getPriceCents(x); });
    complementStraps = adj.concat(rest);
  }

  /* SL cart: the SL line leads, dearest first, so an SL3 owner is shown the Trailflex
     Adjustable SL rather than whichever SL strap the shuffle happened to surface. The
     family key treats Trailflex SL and Trailflex as one strap, so only one build shows. */
  if (cartIsSL && complementStraps.length > 1) {
    var slFirst = [], slRest = [];
    for (var z = 0; z < complementStraps.length; z++) {
      if (isSLStrap(complementStraps[z].title)) slFirst.push(complementStraps[z]);
      else slRest.push(complementStraps[z]);
    }
    slFirst.sort(function(x, y) { return getPriceCents(y) - getPriceCents(x); });
    complementStraps = slFirst.concat(slRest);
  }

  /* A kit or bundle cart gets straps and premium pieces only - no small add-ons,
     Shutter Toppers included. Everywhere else a Shutter Topper is a fair upsell. */
  if (hasKit) shutterToppers = [];

  /* Build tiered result: straps carry the list, no accessory filler */
  var result = [];
  if (complementStraps.length > 0) result.push(complementStraps.shift());
  if (complementStraps.length > 0) result.push(complementStraps.shift());
  if (bigTickets.length > 0) result.push(bigTickets.shift());
  if (complementStraps.length > 0) result.push(complementStraps.shift());
  if (shutterToppers.length > 0) result.push(shutterToppers.shift());
  else if (other.length > 0) result.push(other.shift());

  /* Fill reserve from leftovers */
  var leftovers = [].concat(complementStraps, shutterToppers, bigTickets, other);
  shuffle(leftovers);
  for (var k = 0; k < leftovers.length && result.length < 8; k++) {
    result.push(leftovers[k]);
  }

  return result;
};

/* -- UI Functions -- */
var updateCount = window.updateCount = function() {
  var allChecks = document.querySelectorAll('.cr-drawer-check');
  var checkedCount = 0;
  var uncheckedItems = [];

  for (var i = 0; i < allChecks.length; i++) {
    var row = allChecks[i].closest('div[style*="display"]');
    if (!row) row = allChecks[i].parentElement;
    if (allChecks[i].checked) {
      checkedCount++;
      if (row) row.style.display = 'flex';
    } else {
      uncheckedItems.push(row);
    }
  }

  var budget = MAX_RECS - (window._recsAdded || 0);
  if (budget < 0) budget = 0;
  var slotsLeft = budget - checkedCount;
  if (slotsLeft < 0) slotsLeft = 0;

  for (var j = 0; j < uncheckedItems.length; j++) {
    if (uncheckedItems[j]) {
      uncheckedItems[j].style.display = (j < slotsLeft) ? 'flex' : 'none';
    }
  }

  /* If budget fully exhausted and nothing checked, hide the whole section */
  if (budget === 0 && checkedCount === 0) {
    var w = document.getElementById('cart-drawer-recs');
    if (w) w.style.display = 'none';
    return;
  }

  var counter = document.getElementById('cart-recs-count');
  var addBtn = document.getElementById('cart-recs-add-btn');
  if (counter) counter.textContent = checkedCount + ' item' + (checkedCount !== 1 ? 's' : '') + ' selected';
  if (addBtn) {
    addBtn.disabled = (checkedCount === 0);
    addBtn.style.opacity = (checkedCount === 0) ? '0.4' : '1';
  }
};

var handleAddClick = window.handleAddClick = function() {
  var btn = document.getElementById('cart-recs-add-btn');
  if (!btn || btn.disabled) return;

  var checks = document.querySelectorAll('.cr-drawer-check:checked');
  if (!checks || checks.length === 0) return;

  var items = [];
  checks.forEach(function(cb) {
    var vid = cb.getAttribute('data-variant-id');
    if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
  });
  if (items.length === 0) return;

  /* Track BEFORE the async calls so re-renders can't reset */
  window._recsAdded = (window._recsAdded || 0) + items.length;
  window._recsAddedAt = Date.now();
  window._recsHtmlCache = ''; /* Clear cache so next open fetches fresh recs for new cart */

  btn.disabled = true;
  btn.textContent = 'Adding...';
  btn.style.opacity = '0.4';

  var addNext = function(index) {
    if (index >= items.length) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (window.FoxThemeEvents && window.FoxThemeEvents.publish) {
            FoxThemeEvents.publish('cart:update', cart);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          setTimeout(function() {
            /* Remove checked items from DOM */
            var addedChecks = document.querySelectorAll('.cr-drawer-check:checked');
            if (addedChecks) {
              for (var ci = addedChecks.length - 1; ci >= 0; ci--) {
                var row = addedChecks[ci].closest('div[style*="display"]');
                if (!row) row = addedChecks[ci].parentElement;
                if (row && row.parentElement) row.parentElement.removeChild(row);
              }
            }

            /* Re-enable button */
            var b = document.getElementById('cart-recs-add-btn');
            if (b) { b.disabled = false; b.textContent = 'Add Selected to Cart'; b.style.opacity = '0.4'; }
            if (window.FoxTheme && window.FoxTheme.CartDrawer) FoxTheme.CartDrawer.openDrawer();

            _cartRecsRunning = false;
            updateCount();

            /* If no recs left, hide section */
            var remaining = document.querySelectorAll('.cr-drawer-check');
            if (!remaining || remaining.length === 0) {
              var w = document.getElementById('cart-drawer-recs');
              if (w) w.style.display = 'none';
            }
          }, 600);
        })
        .catch(function() {
          var b = document.getElementById('cart-recs-add-btn');
          if (b) { b.disabled = false; b.textContent = 'Add Selected to Cart'; b.style.opacity = '0.4'; }
          _cartRecsRunning = false;
        });
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [items[index]] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('fail');
      return r.json();
    })
    .then(function() { addNext(index + 1); })
    .catch(function() { addNext(index + 1); });
  };
  addNext(0);
};

/* -- Init & Fetch -- */
var initCartRecs = window.initCartRecs = function() {
  if (_cartRecsRunning) return;

  /* If items were added recently, don't re-init (FoxTheme re-render protection) */
  if (window._recsAdded > 0 && (Date.now() - window._recsAddedAt) < 30000) {
    return;
  }

  _cartRecsRunning = true;

  var wrapper = document.getElementById('cart-drawer-recs');
  if (!wrapper) { _cartRecsRunning = false; return; }
  var list = document.getElementById('cart-recs-list');
  if (!list) { _cartRecsRunning = false; return; }
  if (list.children.length > 0) { _cartRecsRunning = false; return; }

  /* Restore cached HTML if available (drawer was closed and reopened) */
  if (window._recsHtmlCache) {
    list.innerHTML = window._recsHtmlCache;
    wrapper.style.display = 'block';
    var actions = document.getElementById('cart-recs-actions');
    if (actions) actions.style.display = 'block';
    var btn = document.getElementById('cart-recs-add-btn');
    if (btn) {
      btn.onclick = function(e) { e.preventDefault(); e.stopPropagation(); handleAddClick(); };
    }
    updateCount();
    _cartRecsRunning = false;
    return;
  }

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        wrapper.style.display = 'none';
        _cartRecsRunning = false;
        return;
      }
      var cartCameras = getCartCameras(cart);
      /* Fetch recs from MULTIPLE cart items for diversity */
      fetchMultiRecs(cart, list, wrapper, cartCameras);
    })
    .catch(function() { _cartRecsRunning = false; });
};

/* Fetch recs from up to 3 cart items and merge for variety */
/* Falls back to strap collections if filtered recs are too few.
   NOTE: the old fallback browsed /collections/accessories (which is "Straps Accessories":
   lug covers, split rings) and /collections/all. That is what put $9.99 lug covers and
   The Perch under a $794 kit. Straps only now, and the blocklist still applies on top. */
var STRAP_FALLBACK_COLLECTIONS = [
  'trailflex-straps',        /* Trailflex Adjustable - the most versatile strap we make */
  'trailflex-wrist-straps',  /* WristFlex Adjustable */
  'padded-straps',
  'classic-leather-straps',
  'rope-straps',
  'twinpad',
  'wrist-straps'
];

/* An SL cart browses the SL line first; for every other cart these are all rejected by
   isCompatible, so they are only worth fetching when the cart is actually an SL. */
var SL_FALLBACK_COLLECTIONS = ['sl-line-straps', 'twinpad-sl', 'wristflex-sl'];

var fetchMultiRecs = window.fetchMultiRecs = function(cart, list, wrapper, cartCameras) {
  var hasKit = cartHasKit(cart);
  window._recsCartHasKit = hasKit; /* renderRecs has no cart of its own */
  var cartIds = {};
  /* Never offer the same strap in another colour - the cart already has that strap */
  var cartFams = {};
  cart.items.forEach(function(item) {
    cartIds[item.product_id] = true;
    cartFams[getBaseProduct(item.product_title || '')] = true;
  });

  /* Get unique product IDs from cart (max 3) */
  var pids = [];
  var pidSeen = {};
  for (var i = 0; i < cart.items.length && pids.length < 3; i++) {
    var pid = cart.items[i].product_id;
    if (!pidSeen[pid]) { pidSeen[pid] = true; pids.push(pid); }
  }

  var allProducts = [];
  var seenIds = {};
  var fetched = 0;
  var MIN_RECS = 4;

  /* Fallback: browse strap collections to find more compatible products.
     One product per FAMILY only - a strap collection is 12 colourways of the same
     strap, and taking them all used to fill the quota with near-duplicates that the
     dedup pass then threw away, leaving two recommendations on screen. */
  var fillFromCollections = function(existing, cart, cartCameras, cb) {
    var collections = (cartCameras.indexOf('leica-sl') !== -1)
      ? SL_FALLBACK_COLLECTIONS.concat(STRAP_FALLBACK_COLLECTIONS)
      : STRAP_FALLBACK_COLLECTIONS;
    var cIdx = 0;
    var found = existing.slice();
    var foundIds = {};
    var foundFams = {};
    for (var e = 0; e < existing.length; e++) {
      foundIds[existing[e].id] = true;
      foundFams[getBaseProduct(existing[e].title)] = true;
    }

    var tryNext = function() {
      if (cIdx >= collections.length || found.length >= 10) { cb(found); return; }
      var url = '/collections/' + collections[cIdx] + '/products.json?limit=50';
      cIdx++;
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var prods = data.products || [];
          for (var i = 0; i < prods.length && found.length < 10; i++) {
            var p = prods[i];
            if (cartIds[p.id] || foundIds[p.id] || seenIds[p.id]) continue;
            if (!isEligible(p, hasKit)) continue;
            if (!isCompatible(cartCameras, p.title)) continue;
            var fam = getBaseProduct(p.title);
            if (foundFams[fam] || cartFams[fam]) continue;
            foundFams[fam] = true;
            foundIds[p.id] = true;
            seenIds[p.id] = true;
            found.push(p);
          }
          tryNext();
        })
        .catch(function() { tryNext(); });
    };
    tryNext();
  };

  var finalize = function() {
    allProducts.sort(function(a, b) {
      return getRelevanceScore(cartCameras, b.title) - getRelevanceScore(cartCameras, a.title);
    });
    if (allProducts.length < MIN_RECS) {
      /* Not enough compatible recs - try strap collections fallback */
      fillFromCollections(allProducts, cart, cartCameras, function(filled) {
        filled.sort(function(a, b) {
          return getRelevanceScore(cartCameras, b.title) - getRelevanceScore(cartCameras, a.title);
        });
        renderRecs(applySmartTiers(filled, cart, cartCameras).slice(0, 8), list, wrapper);
      });
    } else {
      renderRecs(applySmartTiers(allProducts, cart, cartCameras).slice(0, 8), list, wrapper);
    }
  };

  var onBatch = function(products) {
    for (var i = 0; i < products.length; i++) {
      if (!cartIds[products[i].id] && !seenIds[products[i].id] &&
          !cartFams[getBaseProduct(products[i].title)] &&
          isEligible(products[i], hasKit) && isCompatible(cartCameras, products[i].title)) {
        seenIds[products[i].id] = true;
        allProducts.push(products[i]);
      }
    }
    fetched++;
    if (fetched >= pids.length) {
      finalize();
    }
  };

  for (var p = 0; p < pids.length; p++) {
    (function(pid) {
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=complementary')
        .then(function(r) { return r.json(); })
        .then(function(data) { onBatch(data.products || []); })
        .catch(function() { onBatch([]); });
    })(pids[p]);
  }
};

var renderRecs = window.renderRecs = function(products, list, wrapper) {
  _cartRecsRunning = false;

  /* Last line of defence: never paint a blocked or cheap item, whatever reached here */
  var safe = [];
  if (products) {
    for (var s = 0; s < products.length; s++) {
      if (isEligible(products[s], window._recsCartHasKit)) safe.push(products[s]);
    }
  }
  products = safe;

  if (!products || products.length === 0) {
    wrapper.style.display = 'none';
    return;
  }
  var budget = MAX_RECS - (window._recsAdded || 0);
  if (budget < 0) budget = 0;

  /* If budget exhausted, don't render recs at all */
  if (budget === 0) {
    wrapper.style.display = 'none';
    return;
  }

  wrapper.style.display = 'block';

  var html = '';
  products.forEach(function(p, idx) {
    var rawImg = (p.images && p.images.length > 0) ? p.images[0] : (p.featured_image || '');
    var img = (typeof rawImg === 'object' && rawImg !== null) ? (rawImg.src || '') : (rawImg || '');
    var cents = getPriceCents(p);
    var price = cents ? ('$' + (cents / 100).toFixed(2)) : '';
    var variantId = (p.variants && p.variants.length > 0) ? p.variants[0].id : p.id;
    var hidden = idx >= budget ? 'display:none' : 'display:flex';
    html += '<div style="' + hidden + ';align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid #eee;">';
    html += '<input type="checkbox" class="cr-drawer-check" data-variant-id="' + variantId + '" style="width:18px;height:18px;cursor:pointer;flex-shrink:0;" onchange="window.updateCount()">';
    if (img) html += '<img src="' + img + '" alt="" style="width:50px;height:50px;object-fit:cover;border-radius:4px;flex-shrink:0;">';
    html += '<div style="flex:1;min-width:0;">';
    html += '<div style="font-size:13px;font-weight:500;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + p.title + '</div>';
    html += '<div style="font-size:12px;color:#666;margin-top:2px;">' + price + '</div>';
    html += '</div></div>';
  });
  list.innerHTML = html;
  window._recsHtmlCache = html;

  var actions = document.getElementById('cart-recs-actions');
  if (actions) actions.style.display = 'block';

  var btn = document.getElementById('cart-recs-add-btn');
  if (btn) {
    btn.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      handleAddClick();
    };
  }

  updateCount();
};

/* -- Triggers -- */
initCartRecs();

document.addEventListener('cart:updated', function() {
  /* Block re-fetch if items were added from recs recently */
  if (window._recsAdded > 0 && (Date.now() - window._recsAddedAt) < 30000) return;
  var l = document.getElementById('cart-recs-list');
  if (l) l.innerHTML = '';
  window._recsHtmlCache = ''; /* Cart changed - fetch fresh recs */
  _cartRecsRunning = false;
  setTimeout(initCartRecs, 400);
});

setInterval(function() {
  /* Don't re-init if we added recs recently */
  if (window._recsAdded > 0 && (Date.now() - window._recsAddedAt) < 30000) return;
  var w = document.getElementById('cart-drawer-recs');
  var l = document.getElementById('cart-recs-list');
  if (w && l && l.children.length === 0 && !_cartRecsRunning) {
    initCartRecs();
  }
}, 3000);

var _cartIcons = document.querySelectorAll('[data-cart-toggle], .cart-icon-bubble, [href="/cart"]');
if (_cartIcons) {
  _cartIcons.forEach(function(icon) {
    icon.addEventListener('click', function() {
      var l = document.getElementById('cart-recs-list');
      if (l && l.children.length === 0) {
        _cartRecsRunning = false;
        setTimeout(initCartRecs, 600);
      }
    });
  });
}
